var _path, _path2, _path3, _rect, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6875 24.8115C57.253 25.7975 64.5242 33.8566 64.5242 43.4728H51.4952V41.6181C51.4952 38.3932 49.1509 35.7158 46.0736 35.197V25.7185C46.0736 25.1444 46.5702 24.6963 47.1413 24.7552L47.6875 24.8115Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4741 45.4823H25.4487V61.4654C25.4487 72.2548 34.1953 81.0014 44.9847 81.0014C55.7741 81.0014 64.5206 72.2548 64.5206 61.4654V45.4823H51.4981V47.335C51.4981 50.9315 48.5826 53.847 44.9861 53.847C41.3896 53.847 38.4741 50.9315 38.4741 47.335V45.4823Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4495 43.4768C25.4495 33.8605 32.7206 25.8014 42.2862 24.8155L42.8324 24.7592C43.4035 24.7003 43.9001 25.1484 43.9001 25.7225V35.2007C40.822 35.7189 38.4771 38.3966 38.4771 41.6221V43.4768H25.4495Z",
    fill: "white",
    fillOpacity: 0.96
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.6395,
    y: 37.1008,
    width: 8.68264,
    height: 14.6437,
    rx: 4.34132,
    fill: "#FF744E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.895 7.35315L64.4387 11.1246C64.7704 11.2904 64.7704 11.7637 64.4388 11.9296L56.895 15.7019C56.5958 15.8515 56.2437 15.6339 56.2437 15.2994L56.2437 12.6518L49.4932 12.6518C48.8719 12.6518 48.3682 12.1481 48.3682 11.5268C48.3682 10.9054 48.8719 10.4018 49.4932 10.4018L56.2437 10.4018L56.2437 7.75565C56.2437 7.42114 56.5958 7.20356 56.895 7.35315ZM33.0985 15.7006L25.5547 11.9291C25.223 11.7633 25.223 11.29 25.5546 11.1242L33.0984 7.35181C33.3976 7.20219 33.7497 7.41976 33.7497 7.75429L33.7497 10.402L40.5002 10.402C41.1215 10.402 41.6252 10.9056 41.6252 11.527C41.6252 12.1483 41.1215 12.652 40.5002 12.652L33.7497 12.652L33.7497 15.2981C33.7497 15.6326 33.3977 15.8501 33.0985 15.7006Z",
    fill: "white",
    fillOpacity: 0.96
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIcon);
export default __webpack_public_path__ + "static/media/zoomIcon.257c885ece61bcd78ec9a33737401c80.svg";
export { ForwardRef as ReactComponent };